import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { interval: { type: Number, default: 0 } }
  static HEADER_OFFSET = 72

  connect() {
    this.restoreScrollPosition()
    if (this.intervalValue > 0) {
      this.timer = setInterval(() => {
        sessionStorage.setItem(this.scrollStorageKey, String(window.scrollY || 0))
        window.Turbo.visit(window.location.href, { action: "replace" })
      }, this.intervalValue)
    }
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  get scrollStorageKey() {
    return `auto-refresh:scroll:${window.location.pathname}${window.location.search}`
  }

  restoreScrollPosition() {
    const storedScrollY = sessionStorage.getItem(this.scrollStorageKey)
    const hash = window.location.hash
    if (storedScrollY === null && !hash) return

    const scrollY = Number.parseInt(storedScrollY || "", 10)
    const restore = (attempt = 0) => {
      if (hash) {
        const target = document.querySelector(hash)
        if (target) {
          if (storedScrollY !== null) {
            sessionStorage.removeItem(this.scrollStorageKey)
          }
          this.scrollToTarget(target)
          return
        }

        if (attempt < 10) {
          requestAnimationFrame(() => restore(attempt + 1))
          return
        }
      }

      if (storedScrollY !== null) {
        sessionStorage.removeItem(this.scrollStorageKey)
        window.scrollTo(0, Number.isNaN(scrollY) ? 0 : scrollY)
      }
    }

    requestAnimationFrame(() => restore())
  }

  scrollToTarget(target) {
    const targetTop = target.getBoundingClientRect().top + window.scrollY
    window.scrollTo({
      top: Math.max(targetTop - this.constructor.HEADER_OFFSET, 0),
      left: 0,
      behavior: "auto"
    })
  }
}
